import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import OurGallery from '../Components/Gallery/OurGallery'

const Gallery = () => {
  return (
    <div>
      <Header />
      <OurGallery />
      <Footer />
    </div>
  )
}

export default Gallery
